// extracted by mini-css-extract-plugin
export var cardContainer = "_oh-0";
export var cardHeader = "_oh-2";
export var collapsedState = "_oh-3";
export var dragHandle = "_oh-5";
export var dragHandleIcon = "_oh-6";
export var dragging = "_oh-1";
export var titleArea = "_oh-4";